import { api } from "@api/api";
import { masks } from "@core/utils/masks";
import { MapIntegrationPlan } from "@modules/mapIntegrationPlans/types";
import { MapIntegrationPlanFormValues } from "@modules/mapIntegrationPlans/validations";

export async function editMapIntegrationPlanService(id: string, data: Partial<MapIntegrationPlanFormValues>): Promise<MapIntegrationPlan> {
  if (data.price_integration) {
    const unmaskedValue = Number(masks.unmask(data.price_integration));
    data.price_integration = (unmaskedValue / 100).toFixed(2) as any;
  }

  const { data: mapintegrationplan } = await api.patch<MapIntegrationPlan>(`v1/subscription_mapintegrationplan_admin/${id}/`, data);

  return mapintegrationplan;
}
